// Vue Router 4 — 旧 client-ep/js/router.js の機械的移植版
// ・ defineAsyncComponent + loadVueComponent → 静的 ES import (Vite 取扱い)
// ・ window.router 公開は廃止 (main.js で app.use(router) する)
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Start from '@/views/Start.vue'
import Usage from '@/views/Usage.vue'

const routes = [
  { path: '/', name: 'home', component: Home, meta: { title: 'セキュア問診票' } },
  { path: '/start', name: 'start', component: Start, meta: { title: 'スタート' } },
  { path: '/usage', name: 'usage', component: Usage, meta: { title: '使い方' } },
  // フォールバック: 未知のパスは / へ (?hash= クエリは保持される)
  { path: '/:pathMatch(.*)*', redirect: (to) => ({ path: '/', query: to.query }) }
]

// 配信パスの base を pathname から動的に検出する (旧 router.js 踏襲)。
// - 本番 Firebase Hosting (https://q4cl-client-ep.web.app/?hash=xxx)
//   → pathname=/ → base=/
// - Vite dev server (http://localhost:5173/)
//   → pathname=/ → base=/
// - Live Server で親フォルダを root にした場合 (http://127.0.0.1:5530/Q4CL-client-vite/)
//   → pathname=/Q4CL-client-vite/ → base=/Q4CL-client-vite/
function detectBase() {
  let p = location.pathname.replace(/[^/]*$/, '')
  if (!p.endsWith('/')) p += '/'
  return p
}

const router = createRouter({
  history: createWebHistory(detectBase()),
  routes,
  scrollBehavior: () => ({ top: 0 })
})

router.afterEach((to) => {
  const baseTitle = 'Emuyn Q4CL'
  document.title = to.meta?.title ? `${to.meta.title} | ${baseTitle}` : baseTitle

  // ローカルでサブパス配信のとき、 view path を F5 すると 404 になる旨警告 (旧 router.js 踏襲)
  try {
    const host = location.hostname
    const isLocal = host === 'localhost' || host === '127.0.0.1'
    const subpath = detectBase() !== '/'
    const inViewPath = to.path && to.path !== '/'
    if (isLocal && subpath && inViewPath) {
      console.warn(
        '[Q4CL] このパス (' + to.path + ') を F5 リロードすると 404 になります。' +
        ' Live Server / Vite preview のサブパス配信下では、 直アクセスや F5 がサーバ側で見つかりません。'
      )
    }
  } catch (e) { /* ignore */ }
})

export default router
